import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, Star, Heart } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();
  const { user, toggleFavorite, isFavorite } = useAuth();
  const fav = isFavorite(product._id);

  const handleFav = async (e) => {
    e.preventDefault();
    if (!user) {
      alert('Please log in to add products to your favorites.');
      return;
    }
    try {
      await toggleFavorite(product._id);
    } catch (err) {
      console.error('Favorite Toggle Error:', err);
    }
  };

  return (
    <div className="bg-white rounded-2xl border border-secondary-100 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group">
      <Link to={`/product/${product._id}`}>
        <div className="relative aspect-square overflow-hidden">
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
          />
          <div className="absolute top-3 left-3 flex flex-col gap-1.5 items-start">
            <span className="bg-white/90 backdrop-blur-sm px-2.5 py-1 rounded-full text-[10px] font-bold text-primary-700 uppercase tracking-widest shadow-sm">
              {product.category?.name || product.category || 'General'}
            </span>
            {(product.offer || product.discount > 0 || (product.mrp > product.price)) && (
              <span className="bg-red-600 text-white px-2 py-0.5 rounded-full text-[9px] font-black uppercase tracking-wider shadow-md animate-in fade-in">
                {product.offer || `${product.discount || Math.round(((product.mrp - product.price) / product.mrp) * 100)}% OFF`}
              </span>
            )}
          </div>
          <button
            onClick={handleFav}
            className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm p-2 rounded-full hover:bg-white transition-colors"
          >
            <Heart className={`h-4 w-4 ${fav ? 'text-red-500 fill-current' : 'text-secondary-400'}`} />
          </button>
        </div>
      </Link>
      
      <div className="p-5">
        <div className="flex items-center justify-between mb-2">
          <span className="text-xs font-semibold text-primary-600">{product.brand}</span>
          <div className="flex items-center space-x-1">
            <Star className="h-3 w-3 text-yellow-400 fill-current" />
            <span className="text-xs font-medium text-secondary-500">{product.rating || '4.5'}</span>
          </div>
        </div>
        
        <Link to={`/product/${product._id}`}>
          <h3 className="text-lg font-bold text-secondary-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-1">
            {product.name}
          </h3>
        </Link>
        
        <div className="flex items-center justify-between mt-4">
          <div className="flex flex-col">
            <div className="flex items-baseline space-x-2">
              <span className="text-xl font-black text-secondary-900">₹{product.price}</span>
              {product.mrp > product.price && (
                <span className="text-xs text-secondary-400 line-through font-medium">₹{product.mrp}</span>
              )}
            </div>
            {product.mrp > product.price && (
              <span className="text-[10px] font-bold text-emerald-600">
                Save ₹{product.mrp - product.price}
              </span>
            )}
          </div>
          <button
            onClick={() => addToCart(product)}
            className="bg-primary-600 hover:bg-primary-700 text-white p-2.5 rounded-xl transition-colors shadow-lg shadow-primary-200"
          >
            <ShoppingCart className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
